var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      attrs: {
        action: "",
        drag: "",
        "before-upload": _vm.beforeUpload,
        "http-request": _vm.uploadAction,
        "show-file-list": false,
      },
    },
    [
      _c("i", { staticClass: "el-icon-upload" }),
      _c("div", { staticClass: "el-upload__text" }, [
        _vm._v("拖拉文件到此"),
        _c("em", [_vm._v("或者點擊上傳")]),
      ]),
      _c(
        "div",
        { staticClass: "el-upload__tip", attrs: { slot: "tip" }, slot: "tip" },
        [_vm._v("支援EXCEL檔及CSV檔 不超過1MB")]
      ),
      _c("div", { staticClass: "filename" }, [_vm._v(_vm._s(_vm.filename))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }